import React from "react";
import { LocaleConsumer } from "containers/Intl";
import * as translations from "./translations";

export const I18n = ({ id }) => (
  <LocaleConsumer>
    {(locale ) => translations[locale][id] || translations['en'][id] || id}
  </LocaleConsumer>
);
